import type { GuestCountState } from './GuestCountState'
import { parseGuestCount } from './parseGuestCount'

/** Reads a raw party size from any untrusted source into a typed state; anything the search would reject is not provided. */
export const readGuestCount = (raw: unknown): GuestCountState => {
  const count = parseGuestCount(raw)
  return count === null ? { provided: false } : { provided: true, value: count }
}
